import { http } from "./http";

export const countyLinksApi = {
  list: (params) => http.get("/county-links", { params }).then((r) => r.data),
  getById: (id) => http.get(`/county-links/${id}`).then((r) => r.data),
  create: (payload) => http.post("/county-links", payload).then((r) => r.data),
  update: (id, payload) =>
    http.put(`/county-links/${id}`, payload).then((r) => r.data),
};
